import { css } from '@emotion/css';
import { uiConfig } from '@volumental/common';
import { type JSX } from 'react';

const containerStyle = css`
  padding-inline: 0;
  padding-block: 0;
  display: flex;
  flex-direction: row;
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  cursor: pointer;
  border: 0px solid #000;
  background: rgba(173, 209, 231, 0.2);
  width: 100%;
  min-height: 146px;
  margin-top: 10px;
  margin-bottom: 10px;
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.4);
    }
  }
  transition: box-shadow 150ms cubic-bezier(0.2, 0, 0, 1) 0ms;
  :focus-visible {
    outline-width: 2px;
  }
`;
const textStyle = css`
  font-size: ${uiConfig.styles.fontSizes.regular};
  font-family: ${uiConfig.styles.fontFamily};
  color: black;
  align-items: center;
  align-self: center;
  text-align: left;
  justify-self: left;
  overflow: hidden;
`;
const textbox = css`
  width: 60%;
  overflow: hidden;
  justify-items: center;
  align-self: center;
  padding: 8px;
  margin-right: 8px;
`;

const imageStyle = css`
  max-height: 130px;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 8px;
  margin: 8px;
`;
interface ButtonProps {
  onClick: () => void;
  imageSrc: string;
  title: string;
  description: string;
  altText: string;
}

export function PickerButton({
  onClick,
  imageSrc,
  title,
  description,
  altText,
}: ButtonProps): JSX.Element {
  return (
    <button className={containerStyle} tabIndex={0} onClick={onClick}>
      <img src={imageSrc} alt={altText} className={imageStyle} />
      <div className={textbox}>
        <div className={textStyle} style={{ fontWeight: 'bold' }}>
          {title}
        </div>
        <div
          className={textStyle}
          style={{ fontWeight: 'normal', paddingTop: '4px' }}
        >
          {description}
        </div>
      </div>
    </button>
  );
}
